import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaxToe2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 73.551,
	height: 34.802,
	viewBox: "0 0 73.551 34.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_224",
		"data-name": "Group 224",
		transform: "translate(0.5 0.5)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_52",
			"data-name": "Rectangle 52",
			width: 72.551,
			height: 33.802,
			fill: "none",
			stroke: "#040505",
			strokeWidth: 1,
			opacity: 0
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_223",
			"data-name": "Group 223",
			transform: "translate(19.611 2.859)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_412",
					"data-name": "Path 412",
					d: "M1339.289,319.148a2.275,2.275,0,0,0-2.55-.133c-.341.2-.728.425-1.142.672a22.947,22.947,0,0,1-4.78,2.42c-1.6.282-6.1.513-7.965.6a1.257,1.257,0,0,0-.695.254c-.166-.185-.335-.385-.508-.617-1.1-1.483-3.8-5.209-3.83-5.247a1.056,1.056,0,0,0-1.709,1.24c.027.037,2.737,3.772,3.844,5.265a9.48,9.48,0,0,0,2.243,2.207c.016.031.025.056.042.089a3.355,3.355,0,0,1-1.47,1.412,4.327,4.327,0,0,1-1.752.229c-.046,0-.091.007-.137.008-.171-.344-.4-.773-.7-1.333a30.516,30.516,0,0,0-4.317-5.159,1.055,1.055,0,1,0-1.474,1.511,28.064,28.064,0,0,1,3.931,4.647c.391.729.608,1.156.727,1.4a2.127,2.127,0,0,0-.272,1.329,10.445,10.445,0,0,0,.451,1.932,19.117,19.117,0,0,0,1.443,3.354,6.286,6.286,0,0,0,.461,2.322,1.057,1.057,0,0,0,.693.7,4.317,4.317,0,0,0,1.24.158,7.594,7.594,0,0,0,3.957-1.222c2.528-1.543,10.149-7.325,10.508-7.6.158-.132,3.886-3.258,4.686-6.4C1340.657,321.434,1340.312,319.925,1339.289,319.148Zm-1.125,3.517c-.523,2.057-3.057,4.523-3.952,5.271-.077.059-7.856,5.962-10.294,7.45a5.459,5.459,0,0,1-2.949.912c-.093-.35-.167-.661-.193-.824l.039-.153a1.058,1.058,0,0,0-.134-.831,15.838,15.838,0,0,1-1.451-3.272,7.413,7.413,0,0,1-.353-1.561c.01-.012.018-.012.021-.011a6.3,6.3,0,0,0,2.639-.371,5.77,5.77,0,0,0,2.87-2.988,1.057,1.057,0,0,0-.06-.931c-.108-.188-.216-.4-.309-.593,2.4-.121,5.72-.324,7.146-.576,1.282-.227,3.165-1.3,5.49-2.684.405-.241.783-.466,1.116-.657.138-.079.19-.039.221-.015C1338.221,320.989,1338.434,321.608,1338.165,322.665Z",
					transform: "translate(-1312.069 -316.659)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_413",
					"data-name": "Path 413",
					d: "M1366.919,365.568h-3.167a1.056,1.056,0,1,0,0,2.111h3.167a1.056,1.056,0,0,0,0-2.111Z",
					transform: "translate(-1335.974 -339.752)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_414",
					"data-name": "Path 414",
					d: "M1342.2,365.568h-7.726a1.056,1.056,0,1,0,0,2.111h7.726a1.056,1.056,0,0,0,0-2.111Z",
					transform: "translate(-1322.15 -339.752)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_415",
					"data-name": "Path 415",
					d: "M1317,365.568h-3.167a1.056,1.056,0,0,0,0,2.111H1317a1.056,1.056,0,0,0,0-2.111Z",
					transform: "translate(-1312.405 -339.752)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_416",
					"data-name": "Path 416",
					d: "M1366.491,343.891l-1.009,1.009v-8.466l1.009,1.009a1.056,1.056,0,1,0,1.493-1.493l-2.811-2.811a1.126,1.126,0,0,0-.162-.132c-.025-.016-.052-.028-.078-.042a.973.973,0,0,0-.1-.054.928.928,0,0,0-.105-.033c-.031-.009-.06-.021-.091-.027a1.066,1.066,0,0,0-.413,0c-.032.006-.061.018-.092.027a.968.968,0,0,0-.1.033.95.95,0,0,0-.1.054c-.026.014-.053.026-.078.042a1.075,1.075,0,0,0-.162.132l-2.811,2.811a1.056,1.056,0,1,0,1.493,1.493l1.009-1.009V344.9l-1.009-1.009a1.056,1.056,0,0,0-1.493,1.493l2.811,2.811a1.055,1.055,0,0,0,1.493,0l2.812-2.811a1.056,1.056,0,0,0-1.493-1.493Z",
					transform: "translate(-1334.964 -324.294)",
					fill: "#040505"
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgMaxToe2);
export { ForwardRef as ReactComponent };
